export const DOWNLOAD_TAG_RESTRICTIONS_TEMPLATE_ENDPOINT =
  '/api/tag-restrictions/download-tag-restrictions-template';
export const DOWNLOAD_TAG_CLEANUP_TEMPLATE_ENDPOINT =
  '/api/tag-restrictions/download-tag-cleanup-template';
export const GET_AUTHORIZED_TAGS_ENDPOINT =
  '/api/tag-restrictions/get-authorized-tags';
export const EXECUTE_TAGS_SHEETS =
  '/api/tag-restrictions/execute-tags-load-sheets';
